<template>
  <div>
    <v-container class="fill-height">
      <v-row align="center" justify="center">
        <v-col xl="4" lg="5" md="6">
          <base-error class="mb-4" :errors="error"></base-error>
          <v-card shaped outlined class="py-5">
            <v-card-title class="justify-center font-weight-bold">
              Agregar tarjeta de crédito/débito
            </v-card-title>
            <v-card-text class="px-8">
              <div class="subtitle mt-3 font-weight-bold text-center">
                Ingresa los datos de tu tarjeta
              </div>
              <v-form ref="stripe" v-model="valid">
                <v-row
                  ><v-col>
                    <v-text-field
                      label="Nombre del titular"
                      v-model="mutableName"
                      name="name"
                      type="text"
                      :rules="rules.cards.fullName"
                      required
                      outlined
                      flat
                      dense /></v-col
                ></v-row>
                <v-row no-gutters>
                  <v-col>
                    <v-text-field
                      label="Dirección Línea 1"
                      placeholder="Calle y número"
                      v-model="mutableLine1"
                      :rules="rules.cards.line1"
                      type="text"
                      required
                      outlined
                      flat
                      dense
                  /></v-col>
                </v-row>
                <v-row no-gutters>
                  <v-col>
                    <v-text-field
                      label="Dirección Línea 2"
                      placeholder="Apartamento, local, etc"
                      v-model="mutableLine2"
                      type="text"
                      required
                      outlined
                      flat
                      dense
                  /></v-col>
                </v-row>
                <v-row>
                  <v-col class="pt-2">
                    <v-text-field
                      label="Ciudad"
                      :rules="rules.cards.city"
                      v-model="mutableCity"
                      type="text"
                      outlined
                      flat
                      dense
                  /></v-col>
                </v-row>
                <v-row>
                  <v-col class="pt-2">
                    <v-text-field
                      label="Estado"
                      :rules="rules.cards.state"
                      v-model="mutableState"
                      type="text"
                      required
                      outlined
                      flat
                      dense
                  /></v-col>
                  <v-col class="pt-2">
                    <v-text-field
                      label="País"
                      :rules="rules.cards.country"
                      v-model="mutableCountry"
                      type="text"
                      required
                      disabled
                      outlined
                      flat
                      dense
                  /></v-col>
                </v-row>
                <card
                  class="stripe-card mt-7"
                  :class="{ complete }"
                  :stripe="publishableKey"
                  :options="stripeOptions"
                  @change="complete = $event.complete"
                />
                <v-divider class="my-5"></v-divider>
                <div>
                  <p>
                    <strong>MM/AA:</strong> Fecha de expiración de la tarjeta.
                    MM es el mes a dos dígitos y AA el año a dos dígitos.
                  </p>
                  <p class="mt-3">
                    <strong>CVC:</strong> Código de seguridad de 3 o 4 números
                    situado en el reverso de la tarjeta de crédito.
                  </p>
                </div>
                <v-btn
                  large
                  rounded
                  block
                  color="primary"
                  class="font-weight-bold mt-7"
                  @click="createCard"
                  :disabled="!complete"
                  :loading="isLoading"
                >
                  Agregar tarjeta
                </v-btn>
                <v-btn
                  large
                  text
                  rounded
                  block
                  color="primary"
                  class="font-weight-bold mt-5"
                  @click="$router.push({ name: 'payments' })"
                  >Regresar</v-btn
                >
              </v-form>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import StripeConfig from '@/constants/stripe-config'
import { Card, createToken } from 'vue-stripe-elements-plus'
import { mapGetters } from 'vuex'
import { to } from '@/helpers'
import { PaymentService } from '@/api/api.service'
import { pathOr } from '@/helpers/functional'
import { SESSION_ADD_CARD } from '@/store/mutations.type'
import rules from '@/constants/input-validation'
export default {
  props: {},
  data() {
    return {
      rules,
      valid: true,
      error: '',
      reference: null,
      cardToken: null,
      complete: false,
      isLoading: false,
      stripeOptions: {},
      publishableKey: StripeConfig.publishableKey,
      mutableCity: null,
      mutableCountry: 'México',
      mutableLine1: null,
      mutableLine2: null,
      mutablePostalCode: null,
      mutableState: null,
      mutableName: null
    }
  },
  computed: {
    ...mapGetters({ user: 'getSessionUser', payment: 'getSessionPayment' })
  },
  mounted() {},
  methods: {
    async createCard() {
      if (this.validateForm()) {
        this.isLoading = true
        const billingDetails = {
          address_city: this.mutableCity,
          address_country: 'MX',
          adress_line1: this.mutableLine1,
          adress_line2: this.mutableLine2,
          adress_state: this.mutableState,
          name: this.mutableName
        }
        createToken(billingDetails).then((data) => {
          if (data.token) {
            this.cardToken = pathOr(null, ['token', 'id'], data)
            this.saveCard()
          } else {
            this.error = this.$t('errors.unknownError')
          }
        })
      }
    },
    async saveCard() {
      const payload = {
        card_token: this.cardToken
      }
      const [err, data] = await to(PaymentService.saveCard(payload))
      if (err) {
        this.isLoading = false
        this.error = this.$t('errors.cardDeclined')
      } else {
        const card = pathOr(null, ['data', 'data', 'card'], data)
        this.$store.commit(SESSION_ADD_CARD, card, data)
        this.$noty.success(`La tarjeta se agregó con éxito`)
        this.$router.push({ name: 'credit-card-payment' })
        this.isLoading = false
      }
      this.isLoading = false
    },
    validateForm() {
      return this.$refs.stripe.validate()
    }
  },
  components: {
    Card
  }
}
</script>
<style lang="scss" scoped></style>
